module.exports = __webpack_public_path__ + "media/images/mr4-d9a2ab656c7ad3f6fe3bd511d7b4e81c.jpg";